/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react"

import { useForm, useStepTransition } from "@garantidos/hooks"
import { focusOnLogo } from "@garantidos/utils"

import { useFlags } from "pages/Proposal/hooks/useFlags"

import { ProposalContext, useProposalContext } from "contexts/proposal"

import { infoMessages } from "./data"
import * as trackers from "./trackings"

const useSummary = () => {
  const { form } = useForm({ context: ProposalContext })
  const {
    stepInfo,
    proposalData,
    fetchProposalData,
    sendProposalData,
    errorMessage,
    setErrorMessage,
    errorHandler,
    cpfData,
    isLoading,
    setIsStepVisible
  } = useProposalContext()
  const { stepNavigator } = useStepTransition(setIsStepVisible)
  const { isShareIncome } = useFlags()
  const { hashedCpf } = cpfData
  const { previousStep, nextStep } = stepInfo
  const [infoMessage, setInfoMessage] = useState("")
  const [callerId, setCallerId] = useState("")

  let labelAmortization =
    proposalData.amortization_system === "SAC"
      ? "(Sistema de Amortização Constante)"
      : ""
  labelAmortization = `${proposalData.amortization_system} ${labelAmortization}`

  const onSubmitCallback = async () => {
    if (isLoading) return
    try {
      const payload = {}
      await sendProposalData({ payload })
      trackers.advance()
      stepNavigator("next", nextStep)
    } catch (error) {
      errorHandler(error)
      trackers.alert(hashedCpf, error)
    }
  }

  const handlePrevStep = async () => {
    if (isLoading) return
    try {
      await fetchProposalData({ step: previousStep, recaptcha: true })
      trackers.back(hashedCpf)
      stepNavigator("prev", previousStep)
    } catch (error) {
      errorHandler(error)
      trackers.alert(hashedCpf, error)
    }
  }

  const getInfoMessage = (callerId, groupSituation = "") => {
    const message = infoMessages[callerId]
    return groupSituation ? message[groupSituation] : message
  }

  const handleOpenInfo = (callerId) => {
    const groupSituation =
      callerId === "amortization" ? proposalData.amortization_system : ""
    const message = getInfoMessage(callerId, groupSituation)
    setInfoMessage(message)
    setCallerId(callerId)
  }

  const handleCloseInfo = () => {
    const caller = document.querySelector(`#${callerId}`)
    caller && caller.focus()
    setInfoMessage("")
    setCallerId("")
  }

  const trackDsBackButton = () => {
    trackers.backHome(hashedCpf)
  }

  useEffect(() => {
    trackers.pageview(hashedCpf)

    focusOnLogo()

    const back = document.getElementById("main-logo")
    back.onclick = () => trackDsBackButton()
  }, [])

  return {
    handlePrevStep,
    onSubmitCallback,
    form,
    isShareIncome,
    errorMessage,
    setErrorMessage,
    labelAmortization,
    isSameAddress: proposalData.partner_same_address ? true : false,
    isSameContact: proposalData.partner_same_contact ? true : false,
    handleOpenInfo,
    infoMessage,
    handleCloseInfo,
    setInfoMessage,
    isLoading
  }
}

export default useSummary
